/**
 @author chunfeng
 @date 2020/4/22 11:56
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
let share = config.baseUrl.pro


// 获取当前用户故事版列表
let token01 = null;
export const getTeamSharingList = async (data) => {
    if (token01) {
        token01.cancel({
            status: 'cancel'
        });
    }
    token01 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/GetStoryBoardList?",
        method: "get",
        token: token01.token,
    })
};

// 获取同一用户下是否有相同名称的故事版
let token02 = null;
export const getTeamSharingUserIdentical = async (data) => {
    if (token02) {
        token02.cancel({
            status: 'cancel'
        });
    }
    token02 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/GetStoryBoardNameVerify?" + qs.stringify(data),
        method: "get",
        token: token02.token,
    })
};
// 修改或添加故事版
let token03 = null;
export const addorModifyTeamSharing = async (name) => {

    if (token03) {
        token03.cancel({
            status: 'cancel'
        });
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/SetStoryBoard",
        method: "post",
        token: token03.token,
        data: {
            "id": '',
            "name": name,
            "sizeX": 0,
            "sizeY": 0,
            "sizeLong": 0,
            "sizeWide": 0
        },
        isNoQS: true,
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
    })
};
// 删除故事版
let token04 = null;
export const removeTeamSharing = async (data) => {
    if (token04) {
        token04.cancel({
            status: 'cancel'
        });
    }
    token04 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/RemoveStoryBoard?" + qs.stringify(data),
        method: "get",
        token: token04.token,
    })
};


// 获取当前用户组下具有故事版权限的成员
let token05 = null;
export const GetTeamSharingMembers = async () => {
    if (token05) {
        token05.cancel({
            status: 'cancel'
        });
    }
    token05 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[1] + "/GetTeamSharingMembers",
        method: "get",
        token: token05.token,
    })
};

// 给故事版添加团队分享记录
let token06 = null;
export const addTeamSharingPersonnel = async (data) => {

    if (token06) {
        token06.cancel({
            status: 'cancel'
        });
    }
    token06 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[1] + "/SetTeamSharing",
        method: "post",
        token: token06.token,
        data: data,
        isNoQS: true,
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
    })
};

// 创建大屏分享链接
let token07 = null;
export const SetScreenLinkSharing = async (data) => {
    if (token07) {
        token07.cancel({
            status: 'cancel'
        });
    }
    token07 = axios.token();
    return axios.ajax({
        url: share.wb[1] + "/SetScreenLinkSharing",
        method: "post",
        token: token07.token,
        data: data,
        isNoQS: true,
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
    })
};


